import { useState, useEffect, useRef } from "react";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import { toast } from "react-toastify";
import { CheckboxItem } from "../../components/check/checkbox";
import useGetAllTools from "src/hooks/useGetTools";



export default function AddNewTool() {
  const { userFrameworks, updateUserFrameworks } = useClientSignUpSteps();
  const [localValue, setLocalValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);
  const maxSelection = 3;


    const { loading: loadingAll, error: errorAll, tools: toolsAll, retry: retryAll } = useGetAllTools();


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);

    if (value.trim()) {
      const filtered = (toolsAll ?? []).filter((t) =>
        t.name && t.name.toLowerCase().includes(value.toLowerCase())
      );

      setSuggestions(filtered.map(t => t.name));
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectSuggestion = (tool) => {
    if (userFrameworks.length >= maxSelection) {
      toast.info("You have selected maximum number of Tools");
      setShowSuggestions(false);
      return;
    }
    
    const alreadyExists = userFrameworks.some(
      (t) => t.name.toLowerCase() === tool.toLowerCase()
    );
    
    if (alreadyExists) {
      toast.info("This tool is already added");
      setShowSuggestions(false);
      return;
    }

    updateUserFrameworks([
      ...userFrameworks,
      {
        id: `custom-${Date.now()}`,
        name: tool,
        experience: undefined,
      },
    ]);
    setLocalValue("");
    setShowSuggestions(false);
  };

  const handleConfirmOther = () => {
    if (localValue.trim()) {
      if (userFrameworks.length >= maxSelection) {
        toast.info("You have selected maximum number of Tools");
        return;
      }
      const alreadyExists = userFrameworks.some(
        (t) => t.name.toLowerCase() === localValue.trim().toLowerCase()
      );
      if (alreadyExists) {
        toast.info("This tool is already added");
        return;
      }

      updateUserFrameworks([
        ...userFrameworks,
        {
          id: `custom-${Date.now()}`,
          name: localValue.trim(),
          experience: undefined,
        },
      ]);
      setLocalValue("");
      setShowSuggestions(false);
    }
  };

  return (
    <div>
    <div ref={containerRef} className="mt-2 animate-in fade-in slide-in-from-top-1 duration-300 relative">

{/* 
      <div className="flex w-full items-center justify-between gap-4 pb-4 py-1 border-b- border-gray-100">
                      <p className="text-semibold">Add Tools</p>

                        <div className="text-xs text-bold  px-2 py-1 rounded-lg">
            {userFrameworks.length} / {maxSelection}
          </div>
                  
                    </div> */}

{/* This is used to display the selected info */}
      <div className="flex items-center gap-3 mb-4"   > 

        {/* {userFrameworks.filter(t => t.id.toString().startsWith('custom-')).map((customTool) => (
          <CheckboxItem
            key={customTool.id}
            selected={true}
            onSelect={() => {
              updateUserFrameworks(userFrameworks.filter(each => each.id !== customTool.id))
            }}
          >
            {customTool.name}
          </CheckboxItem>
        ))} */}

        </div>

      <div className="relative">
        <input
          type="text"
          placeholder="Type tool and press Enter"
          className="w-full p-3 rounded-xl border-2 border-primary/20 focus:border-primary outline-none
           transition-all bg-white shadow-sm"
          value={localValue}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleConfirmOther();
            }
          }}
          onFocus={() => {
        
          }}
        />
     
  {/* {showSuggestions && (
  <div className="absolute z-50 w-full mt-2 bg-white border border-gray-100 rounded-xl shadow-xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
    {loadingAll ? (
      <div className="p-4 text-muted-foreground text-center">Loading...</div>
    ) : suggestions.length > 0 ? (
      <div className="max-h-60 overflow-y-auto">
        {suggestions.map((tool, index) => (
          <button
            key={index}
            onClick={() => handleSelectSuggestion(tool)}
            className="w-full text-left px-4 py-3 text-sm hover:bg-primary/5 transition-colors border-b border-gray-50 last:border-0 group flex items-center justify-between"
          >
            <span className="font-medium text-gray-700 group-hover:text-primary">{tool}</span>
            <span className="text-[10px] text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity">Add</span>
          </button>
        ))}
      </div>
    ) : (
      <div className="p-4 text-muted-foreground text-center">No tools found.</div>
    )}
  </div>
)} */}

        
      </div>

      </div>
    </div>
  );
}